/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';

registerLocaleData(localeEs);

const mergedConfig = {
  ...appConfig,
  providers: [...(appConfig.providers || []), { provide: LOCALE_ID, useValue: 'es' }],
};

bootstrapApplication(AppComponent, mergedConfig).catch(err => console.error(err));
